import { actionTypes } from '@/core/constants'
import DocumentosUrlBuilder from '@/core/utils/factory/documentos/DocumentosUrlBuilder'
import DocumentoPncpApiClient from '@/core/apiclient/documentos/pncp/DocumentoPncpApiClient'

function getApiClient(obj) {
	const urlBuilder = new DocumentosUrlBuilder(obj.tipo)
	return new DocumentoPncpApiClient(urlBuilder)
}

export default {
	async [actionTypes.DOCUMENTOS.PNCP.ENVIAR_DOCUMENTO_GENERICO](context, objt) {
		let apiClient = getApiClient(objt)
		let { data } = await apiClient.enviarDocumentoPncp(objt)
		return data
	},
	async [actionTypes.DOCUMENTOS.PNCP.EXCLUIR_DOCUMENTO_GENERICO](context, objt) {
		let apiClient = getApiClient(objt)
		let { data } = await apiClient.excluirDocumentoPncp(objt)
		return data
	},
}
